import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { ITimeCard } from '../itime-card';
import * as TimeCardActions from './time-card.actions';

export const timeCardsFeatureKey = 'timeCards';

export interface State extends EntityState<ITimeCard> {
    // additional entities state properties
}
// have to specify function to get the uniqueid column since we're not using "id"
export const adapter: EntityAdapter<ITimeCard> =
    createEntityAdapter<ITimeCard>();
// { selectId: (model: ITimeCard) => model.EmpTimeID }

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

const timeCardReducer = createReducer(
    initialState,
    on(TimeCardActions.addTimeCard, (state, action) =>
        adapter.addOne(action.timeCard, state)
    ),
    on(TimeCardActions.upsertTimeCard, (state, action) =>
        adapter.upsertOne(action.timeCard, state)
    ),
    on(TimeCardActions.addTimeCards, (state, action) =>
        adapter.addMany(action.timeCards, state)
    ),
    on(TimeCardActions.upsertTimeCards, (state, action) =>
        adapter.upsertMany(action.timeCards, state)
    ),
    on(TimeCardActions.updateTimeCard, (state, action) =>
        adapter.updateOne(action.timeCard, state)
    ),
    on(TimeCardActions.updateTimeCards, (state, action) =>
        adapter.updateMany(action.timeCards, state)
    ),
    on(TimeCardActions.deleteTimeCard, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(TimeCardActions.deleteTimeCards, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(TimeCardActions.loadTimeCards, (state, action) =>
        adapter.setAll(action.timeCards, state)
    ),
    on(TimeCardActions.clearTimeCards, state => adapter.removeAll(state))
);

export function reducer(state: State | undefined, action: Action) {
    return timeCardReducer(state, action);
}
